<template>
    <div class="conf-wrp">
        <div class="content-wrp">
            <div class="content">
                <el-form class="form" :model="value" :rules="rules" ref="form" label-width="20%">
                    <section>
                        <div class="title">
                            <span>库存设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="铺货时，进行库存默认设置:" >
                                <el-switch v-model="checkInstock"></el-switch>
                            </el-form-item>
                            <el-form-item v-if="checkInstock" label="库存默认值" prop="instock">
                                <div class="instock">
                                    <span class="prev">铺货到京东到SKU库存默认值&nbsp;=&nbsp;</span>
                                    <el-input v-model="value.instock" style="width: 120px" placeholder="请输入库存数"></el-input>
                                    <span class="tips">&nbsp;(此值应用于商品铺货时，对商品各SKU的库存初始化值，最大值为99999)</span>
                                </div>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>基础设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="店铺品牌设置：">
                                <BrandSettingConfig
                                    v-if="shopList.length"
                                    ref="branchSettingConfig"
                                    v-model="brandConfList"
                                    :shopList="shopList"
                                />
                                <span class="no-shops" v-else>暂无平台店铺</span>
                            </el-form-item>
                            <el-form-item label="类目外品牌设置：">
                                <BrandSettingOtherConfig
                                    v-if="shopList.length"
                                    ref="BrandSettingOtherConfig"
                                    v-model="dataSourceCategory"
                                    :shopList="shopList"
                                />
                                <span class="no-shops" v-else>暂无平台店铺</span>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>图片设置</span>
                        </div>
                        <div class="conf">
                            <div style="padding-left:15%;">图片修正规则：按照平台比例和尺寸大小要求，修正成最优且符合要求的图片。若图片大小不符合平台要求，将自动压缩后重新上传，不支持压缩20M以上的图片。</div>
                            <el-form-item prop="autoCropImageConfigList">
                                <el-checkbox-group v-model="value.autoCropImageConfigList">
                                    <el-checkbox label="mainImg">商品展示图</el-checkbox>
                                    <el-checkbox label="mainLengthImg">商品长图</el-checkbox>
                                    <el-checkbox label="skuLengthImg">规格长图</el-checkbox>
                                    <el-checkbox label="skuImg">规格图</el-checkbox>
                                    <el-checkbox label="searchImg">搜索推荐图</el-checkbox>
                                </el-checkbox-group>
                                <el-checkbox-group></el-checkbox-group>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>运费模板设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="运费设置:" prop="shipSet" label-width="120px">
                                <div class="ship-wrp" v-if="shopList.length > 0">
                                    <div class="item" v-for="(item, idx) in shopList" :key="idx">
                                        <div class="shopname" :data-id="item.id">
                                            <img class="shop-img" :src="item.icon"/>
                                            <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px -6px 0px 6px;">
                                                <el-image :src="item.channelIcon" style="width: 18px; height: 18px;overflow: unset;top: 4px;"></el-image>
                                            </el-tooltip>
                                            <span>{{ item.shortTitle || item.title }}</span>
                                        </div>
                                        <el-select 
                                            :loading="selectLoading" 
                                            v-model="shipsValue[item.id]" 
                                            placeholder="请选择运费模板" 
                                            clearable
                                            @visible-change="changeSelect(item.id, item.userId)"
                                            width="150px">
                                            <el-option
                                                v-for="ship in shipsTemplate[item.id]"
                                                :key="ship.id"
                                                :label="ship.name"
                                                style="width: 150px;"
                                                :title="ship.name"
                                                :value="ship.id">
                                            </el-option>
                                        </el-select>
                                        <div><el-link class="no-border" @click="refreshTemplate(item.id, item.userId)">刷新模板</el-link></div>
                                    </div>
                                </div>
                                <span v-else class="no-shops">暂无平台店铺</span>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>上架设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="上架设置:" prop="shelfType">
                                <el-radio-group v-model="value.shelfType">
                                    <el-radio :label="1">立即上架</el-radio>
                                    <el-radio :label="2">放入草稿箱</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </section>
                    <PriceConf ref="PriceConfRef" platform="jd" :priceList="value.price" :shopPriceConf="value.shopPriceConf"></PriceConf>
                    <div class="btns">
                        <el-button type="primary" @click="save">保存模板</el-button>
                        <el-button @click="back">返回</el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import '@/assets/css/prod.scss';
import {getDistributionConfig, updateDistributionConfig, getJdTemplates} from '@servers/prod/conf/index.js'
import PriceConf from './components/PriceConf.vue';
import BrandSettingConfig from './components/BrandSettingConfig/';
import BrandSettingOtherConfig from './components/BrandSettingOtherConfig/';
import { cloneDeep } from 'lodash';

const PLATFORMID = 'JdShop';

export default {
    components: {
        PriceConf,
        BrandSettingConfig,
        BrandSettingOtherConfig
    },
    props: {
        back: Function
    },
    provide(){
        return {
            platform:'jd',
        }
    },
    data() {
        const validateInstock = (rule, value, callback) => {
            const reg = /^[0-9]*$/;
            if (value === '') {
                callback(new Error('请输入库存数'));
            } else if (!reg.test(value)) {
                callback(new Error('库存数必须是数字, 且为整数'))
            } else if (value <= 0 || value >= 99999) {
                callback(new Error('库存数必须为0-99999之间的整数'))
            } else {
                callback();
            }
        }
        return {
            checkInstock: false,
            shopList: [],
            value: {
                instock: null,
                shelfType: 2,
                autoCropImageConfigList:[]
            },
            selectLoading: false,
            rules: {
                instock: [
                    {required: true, message: '请输入库存数'},
                    {validator: validateInstock}
                ],
                shelfType: [
                    {required: true, message: ''},
                ]
            },
            shipsValue: {// 运费模板
            },
            shipsTemplate: { // 运费模板列表

            },
            categoryBrandRelationsList:[],
            brandConfList: [],
        }
    },
    computed:{
        dataSourceCategory: {
            get(){
                if (!this.categoryBrandRelationsList?.length) {
                    return [];
                }
                return this.categoryBrandRelationsList.flatMap(item => 
                    item.relations.map(childRelation => ({
                        ...childRelation,
                        previewCategoryId: childRelation.categoryId,
                        parent: { shopId: item.shopId }
                    }))
                );
            },
            set(next){
                const grouped = {};
                (next || []).forEach(row => {
                    const shopId = row?.parent?.shopId;
                    if(!shopId) return;
                    if(!grouped[shopId]) grouped[shopId] = [];
                    const copy = { ...row };
                    delete copy.parent;
                    delete copy.previewCategoryId;
                    grouped[shopId].push(copy);
                });
                this.categoryBrandRelationsList = Object.keys(grouped).map(shopId => ({
                    shopId: isNaN(Number(shopId)) ? shopId : Number(shopId),
                    shopType: PLATFORMID,
                    relations: grouped[shopId]
                }));
            }
        }
    },
    mounted() {
        this.getConf();
    },
    methods: {
        async getConf() {
            const res = await getDistributionConfig({shopType: PLATFORMID});
            const shopList = this.$store.getters.get_AllShops_BySource('jd');
            this.shopList = shopList;
            if (res) {
                this.checkInstock = res.isCommodityStock === 1;
                this.value.instock = res.stockNumber;
                this.value.shelfType = res.shelfState || this.value.shelfType;
                this.value.price = res.price ? JSON.parse(res.price) : [];
                this.value.shopPriceConf = res.shopPriceConf ? JSON.parse(res.shopPriceConf) : [];
                this.value.autoCropImageConfigList = res.autoCropImageConfigList ? res.autoCropImageConfigList : [];
            }
            this.intiTemplate(shopList, res && res.templateList);

            const {  categoryBrandRelations = [],brandConfList} = res || {};
            this.categoryBrandRelationsList = categoryBrandRelations
            this.handleUniqData(brandConfList || []);
        },
        handleUniqData(value){
            const list = cloneDeep(value)
            const data = list.map((item,index)=>{
                // item.id = uniqueId(index+'_')
                item.id = index+'_'+item.shopIds.join('')
                return item
            })
            // console.log(data, list, 'newValue--');
            this.brandConfList = data
        },
        async getTemplateList(userId) {
            const list = await getJdTemplates({
                // offset: 0,
                // limit: 100,
                // searchUsed: false,
                userId: userId
            });
            if (list) {
                return list.map(ship => {
                    return {
                        name: ship.template_name,
                        id: ship.id.toString()
                    }
                });
            }
            return false;
        },
        async refreshTemplate(shopId, userId) {
            this.selectLoading = true;
            const res = await this.getTemplateList(userId);
            const list = res || []
            this.shipsTemplate[shopId] = list;
            const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
            if (idx === -1) {
                this.shipsValue[shopId] = '';
            }
            this.selectLoading = false;
            res && this.$message.success('刷新模板成功')
        },
        intiTemplate(shopList, templateList=[]) {
            const ships = {};
            const shopUserIdMap = {};
            for(let shop of shopList) {
                ships[shop.id] = '';
                shopUserIdMap[shop.userId] = shop.id;
                this.shipsTemplate[shop.id] = [];
            }
            const shipsTemp = {};
            if (shopList.length && templateList) {
                    templateList.forEach(item => {
                        item.shopId = shopUserIdMap[item.shopId] || item.shopId;
                        ships[item.shopId] = item.templateId;
                        if (this.shipsTemplate[item.shopId] && !this.shipsTemplate[item.shopId].length) {
                            shipsTemp[item.shopId] = [{name: item.templateName, id: item.templateId}]
                        }
                    })
            }
            this.shipsTemplate = shipsTemp;
            this.shipsValue = ships;
        },
        async changeSelect(shopId, userId) {
            if (!this.shipsTemplate[shopId] || !this.shipsTemplate[shopId].length ||
                (this.shipsTemplate[shopId].length === 1 && this.shipsTemplate[shopId][0].id === this.shipsValue[shopId])) {
                this.selectLoading = true;
                const list = await this.getTemplateList(userId)
                const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
                if (idx === -1) {
                    this.shipsValue[shopId] = '';
                }
                this.shipsTemplate[shopId] = list;
                this.selectLoading = false;
            }
        },
        findTemplateName(shopid, tempId) {
            if (!this.shipsTemplate[shopid]) return '';
            for(let item of this.shipsTemplate[shopid]) {
                if (item.id === tempId) {
                    return item.name;
                }
            }
        },
        // getBrandConfParamsNew() {
        //     const _categoryBrandRelationsList = Object.assign([], this.categoryBrandRelationsList)
        //     const data = _categoryBrandRelationsList.map((item)=>{
        //         const relations = item.relations.map(rel => {
        //             delete rel.parent
        //             return rel
        //         })
        //         return {
        //             shopId: item.shopId,
        //             shopType: 'jd',
        //             relations,
        //         }
        //     })
        //     return data.filter(item=>item.relations.length!=0)
        // },
        save() {
            this.$refs.form.validate(async valid => {
                if (valid) {
                    const {
                        instock,
                        shelfType,
                        autoCropImageConfigList
                    } = this.value;
                    const templateList = [];
                    Object.keys(this.shipsValue).forEach(id => {
                        const name = this.findTemplateName(id, this.shipsValue[id]);
                        // if (this.shipsValue[id] && name) {
                            const channel = this.shopList.find(shop => shop.id == id)?.channel
                            templateList.push({
                                shopId: id, // id 不是 userId
                                templateId: this.shipsValue[id] || null,
                                templateName: name || null,
                                channel
                            });
                        // }
                    })
                    // const categoryBrandRelations = this.getBrandConfParamsNew()
                    let [commConf, shopConf] = this.$refs.PriceConfRef.getData();
                    const res = await updateDistributionConfig({
                        shopType: PLATFORMID,
                        isCommodityStock: this.checkInstock ? 1 : 0,
                        stockNumber: this.checkInstock ? `${instock === null ? '' : instock}` : '',
                        templateList: templateList,
                        shelfState: shelfType,
                        categoryBrandRelations: this.categoryBrandRelationsList,
                        brandConfList: this.brandConfList,
                        price: JSON.stringify(commConf),
                        shopPriceConf:JSON.stringify(shopConf),
                        autoCropImageConfigList,
                    });
                    if (res) {
                        this.getConf();
                        this.$message.success('保存成功');
                    }
                }
            })
        },
    }
}
</script>

<style lang="scss">
.conf-wrp .sku-item {
       display: flex;
        flex-direction: column;
        &>span {
            color: #aaa;
            font-size: 12px;
        }
   } 
</style>